import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

export const row = style(
  {
    display: "flex",
    flexDirection: "column",

    $nest: {
      "&>div": {
        marginBottom: "1rem"
      }
    }
  },
  media(queries.medium, {
    flexDirection: "row",
    marginBottom: "3rem",

    $nest: {
      "&>div": {
        marginBottom: 0,
        $nest: {
          "&:first-child": {
            marginRight: "2rem"
          }
        }
      }
    }
  })
);

export const phoneNumberInput = style({
  display: "flex"
});

export { labeledInput } from "components/Input/styles";

export const footer = style(
  {
    display: "flex",
    alignItems: "center",
    marginBottom: "3rem",
    flexDirection: "column"
  },
  media(queries.medium, {
    flexDirection: "row"
  })
);

export const error = style({
  flex: 1
});

export const actions = style(
  {
    width: "100%",
    flex: 1,
    display: "flex",
    flexDirection: "column-reverse",
    marginTop: "1rem",
    $nest: {
      button: {
        marginBottom: "1rem"
      }
    }
  },
  media(queries.medium, {
    flexDirection: "row",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: 0,

    $nest: {
      button: {
        marginBottom: 0,
        marginLeft: "2rem"
      }
    }
  })
);

export const selectStyles = {
  control: (styles: React.CSSProperties) => ({
    ...styles,
    width: "7rem",
    backgroundColor: colors.hooplaBackground,
    border: `2.5px solid ${colors.hooplaPurple}`,
    borderRadius: "9px",
    height: "66px",
    marginRight: "0.5rem",
    fontSize: "22px"
  }),
  placeholder: (styles: React.CSSProperties) => ({
    ...styles,
    marginLeft: "1rem"
  }),
  singleValue: () => ({
    color: colors.hooplaTextColor,
    marginLeft: "1rem"
  }),
  indicatorSeparator: () => ({}),
  option: (styles: React.CSSProperties) => ({
    ...styles,
    backgroundColor: colors.hooplaBackground,
    color: colors.hooplaTextColor,
    ":hover": {
      backgroundColor: colors.hooplaBlue,
      cursor: "pointer"
    }
  }),
  menu: (styles: React.CSSProperties) => ({
    ...styles,
    backgroundColor: colors.hooplaBackground
  }),
  dropdownIndicator: (styles: React.CSSProperties) => ({
    ...styles,
    color: colors.hooplaBlue,
    ":hover": {
      color: colors.hooplaGray
    }
  })
};
